import graphql__e3427f543d1cde1ba7b9 from "./__generated__/TransferAppDestination_transferRequestDestination.graphql.ts";
import graphql__8e8f8f66145a8a539724 from "./__generated__/TransferAppDestinationCancelMutation.graphql.ts";import { Alert, Button, MessagePanel } from '@portal/components'
import graphql from 'babel-plugin-relay/macro'
import { useAppToDatabaseRename } from 'components/hooks'
import React, { useState } from 'react'
import { useFragment } from 'react-relay/hooks'
import { usePortalMutation } from 'utils'

import { TransferAppDestination_transferRequestDestination$key } from './__generated__/TransferAppDestination_transferRequestDestination.graphql'
import { TransferAppDestinationCancelMutation } from './__generated__/TransferAppDestinationCancelMutation.graphql'

const fragment = graphql__e3427f543d1cde1ba7b9

const cancelTransferMutation = graphql__8e8f8f66145a8a539724

type Props = {
  /** App ID */
  appId: string
  /** Destination entity */
  destination: TransferAppDestination_transferRequestDestination$key
  /** True if the user is allowed to cancel the transfer request. */
  canCancel: boolean
}

const TransferAppDestination: React.FC<Props> = ({
  destination,
  appId,
  canCancel,
}) => {
  const data = useFragment(fragment, destination)

  const { databaseText } = useAppToDatabaseRename()

  const [cancelTransferRequest, isCancelingTransferRequest] =
    usePortalMutation<TransferAppDestinationCancelMutation>(
      cancelTransferMutation,
      {
        mutationName: 'CancelAppTransferRequest',
        sentryContext: {
          component: 'TransferAppDestination',
          appId,
        },
        showErrorToast: false,
      },
    )
  const [cancelRequestError, setCancelRequestError] = useState<Error>()

  const handleCancelTransferRequest = () => {
    cancelTransferRequest({
      variables: { appId },
      onError: setCancelRequestError,
    })
  }

  const destinationTypeName =
    data?.__typename === 'Organization' ? 'organization' : 'user'

  const destinationName =
    data?.__typename === 'Organization'
      ? data.name
      : data.__typename === 'UserDestination'
        ? data.email
        : null

  return (
    <>
      {!!cancelRequestError && (
        <Alert
          variant="danger"
          autoDismiss={false}
        >{`Error cancelling the transfer request: ${cancelRequestError.message}`}</Alert>
      )}

      <MessagePanel
        variant="danger"
        message={() => (
          <>
            This {databaseText} is pending transfer to {destinationTypeName}{' '}
            <span className="font-medium">{`"${destinationName}"`}</span>. If
            you want to cancel this request you must do so before the transfer
            is accepted by the recipient.
          </>
        )}
        className="mt-4 max-w-xl"
      />

      {!!canCancel && (
        <Button
          variant="critical"
          onClick={handleCancelTransferRequest}
          disabled={isCancelingTransferRequest}
          className="mt-8"
        >
          Cancel request
        </Button>
      )}
    </>
  )
}

export default TransferAppDestination
